var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper",style:({ backgroundImage: `url(${_vm.wrapperText.imgSrc})` })},[_c('div',{staticClass:"container"},[_c('p',{staticClass:"title"},[_vm._v(_vm._s(_vm.wrapperText.title))]),_c('p',{staticClass:"description"},[_vm._v(_vm._s(_vm.wrapperText.desc))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }